<template> 
    <div style="text-align:center; width:100%">
  </div>
</template>



<script>
export default {
  name: "Logout",
  
  mounted() {
    sessionStorage.removeItem("authToken");
    this.$router.replace("/Login");
  }
};
</script>


<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>
